import React from 'react';
import { ReferenceImageSlide } from './ReferenceImageSlide';
import type { SlideProps } from './SlideShell';
export function SlideReferenceCampaignJourney(props: SlideProps) {
  return <div className="relative h-full w-full overflow-hidden bg-[var(--bg)]" data-id="element-159" data-mp="23xf7hs7t0jil">
      <ReferenceImageSlide {...props} src="https://cdn.magicpatterns.com/uploads/6Awn19GaXs9cEABiGJD9M4/Screenshot_2026-08-21_at_10.36.55.png" alt="Each campaign becomes a short interactive journey" recolorOrange data-id="element-160" data-mp="23zhue3dntwj3" />
      <div className="absolute left-[5.15%] top-[5.1%] bg-[var(--bg)] pr-4" data-id="element-161" data-mp="1g8m8fmvvxvjr">
        <p className="text-[clamp(0.65rem,0.95vw,0.95rem)] font-bold uppercase tracking-[0.18em] text-[#00423B]" data-id="element-162" data-mp="1l64glb22w6qp">
          Campaign Example
        </p>
      </div>
    </div>;
}